import axios from 'axios';

/**
 * Download a file from an endpoint that needs a login.
 * A plain <a href> cannot send the Authorization header, so fetch it and save the result.
 */
export async function downloadFile(url, filename, params) {
  const res = await axios.get(url, { responseType: 'blob', params });
  const blobUrl = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
}
